const $5c44653aa16276b5$export$7a5d735b2ab6389d = {
    batteryCapacity: document.getElementById('batteryCapacity'),
    efficiencySlider: document.getElementById('efficiencySlider'),
    efficiencyVal: document.getElementById('efficiencyVal'),
    currentSoCVal: document.getElementById('currentSoCVal'),
    targetSoCVal: document.getElementById('targetSoCVal'),
    socSlider: document.getElementById('socSlider'),
    handleCurrent: document.getElementById('handleCurrent'),
    handleTarget: document.getElementById('handleTarget'),
    sliderFill: document.getElementById('sliderFill'),
    togglePowerMode: document.getElementById('togglePowerMode'),
    toggleText: document.getElementById('toggleText'),
    kwSelector: document.getElementById('kwSelector'),
    vaSelector: document.getElementById('vaSelector'),
    presetContainer: document.getElementById('presetContainer'),
    voltageText: document.getElementById('voltageText'),
    customKwInput: document.getElementById('customKwInput'),
    customKwValue: document.getElementById('customKwValue'),
    inputVolts: document.getElementById('inputVolts'),
    inputAmps: document.getElementById('inputAmps'),
    departureTime: document.getElementById('departureTime'),
    resEnergy: document.getElementById('resEnergy'),
    resWallEnergy: document.getElementById('resWallEnergy'),
    resHours: document.getElementById('resHours'),
    resMins: document.getElementById('resMins'),
    resDeparture: document.getElementById('resDeparture'),
    resPlugTime: document.getElementById('resPlugTime'),
    resPlugAMPM: document.getElementById('resPlugAMPM'),
    vaResultKw: document.getElementById('vaResultKw'),
    themeToggle: document.getElementById('themeToggle'),
    themeIcon: document.getElementById('themeIcon')
};


const $cd24e25165f686be$export$36b79d2b85570e14 = {
    uk: {
        name: 'UK/Ireland',
        volts: 230,
        presets: [
            {
                a: 6
            },
            {
                a: 8
            },
            {
                a: 10
            },
            {
                a: 13,
                label: 'UK Socket'
            },
            {
                a: 16
            },
            {
                a: 32,
                label: 'Wallbox'
            }
        ]
    },
    eu: {
        name: 'Europe',
        volts: 230,
        presets: [
            {
                a: 6
            },
            {
                a: 8
            },
            {
                a: 10
            },
            {
                a: 16,
                label: 'Standard'
            },
            {
                a: 20
            },
            {
                a: 32,
                label: 'Wallbox'
            }
        ]
    },
    na: {
        name: 'North America',
        volts: 120,
        presets: [
            {
                a: 12,
                v: 120,
                label: 'L1 Household'
            },
            {
                a: 16,
                v: 240,
                label: 'L2 16A'
            },
            {
                a: 24,
                v: 240,
                label: 'L2 24A'
            },
            {
                a: 32,
                v: 240,
                label: 'L2 32A'
            },
            {
                a: 40,
                v: 240,
                label: 'L2 40A'
            },
            {
                a: 48,
                v: 240,
                label: 'L2 48A'
            }
        ]
    },
    au: {
        name: 'Australia/NZ',
        volts: 230,
        presets: [
            {
                a: 6
            },
            {
                a: 10,
                label: 'AU Socket'
            },
            {
                a: 15
            },
            {
                a: 32,
                label: 'Wallbox'
            }
        ]
    },
    sa_low: {
        name: 'South America (120V)',
        volts: 120,
        presets: [
            {
                a: 12,
                v: 120,
                label: 'Household'
            },
            {
                a: 16,
                v: 240
            },
            {
                a: 32,
                v: 240
            }
        ]
    },
    sa_high: {
        name: 'South America (220V)',
        volts: 220,
        presets: [
            {
                a: 10
            },
            {
                a: 16
            },
            {
                a: 32
            }
        ]
    },
    jp: {
        name: 'Japan',
        volts: 100,
        presets: [
            {
                a: 15,
                v: 100
            },
            {
                a: 16,
                v: 200
            },
            {
                a: 30,
                v: 200
            }
        ]
    },
    cn: {
        name: 'China',
        volts: 220,
        presets: [
            {
                a: 8
            },
            {
                a: 10
            },
            {
                a: 13
            },
            {
                a: 16
            },
            {
                a: 32
            }
        ]
    }
};


function $da10314c8029a7e4$export$cce993fac5dd4f0d() {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const lang = navigator.language.toLowerCase();
    if (tz.includes('America')) {
        // Split South America
        const saHighCities = [
            'Santiago',
            'Buenos_Aires',
            'Montevideo',
            'Lima',
            'Asuncion'
        ];
        if (saHighCities.some((city)=>tz.includes(city))) return 'sa_high';
        else if (tz.includes('Sao_Paulo')) return 'sa_low'; // Brazil is mixed, but 127V is common
        else if (tz.includes('Bogota') || tz.includes('Caracas') || tz.includes('Guayaquil')) return 'sa_low';
        else return 'na';
    } else if (tz.includes('London') || tz.includes('Dublin') || lang.includes('en-gb')) return 'uk';
    else if (tz.includes('Sydney') || tz.includes('Melbourne') || tz.includes('Auckland') || tz.includes('Perth')) return 'au';
    else if (tz.includes('Tokyo') || tz.includes('Seoul')) return 'jp';
    else if (tz.includes('Shanghai') || tz.includes('Hong_Kong') || tz.includes('Chongqing')) return 'cn';
    else return 'eu';
}




const $fb7559346d9f31fe$var$STORAGE_KEY = 'ev_planner_state';
const $fb7559346d9f31fe$var$DEFAULT_STATE = {
    batteryCapacity: 54,
    currentSoC: 20,
    targetSoC: 80,
    powerMode: 'kw',
    chargingSpeed: 7.4,
    volts: 230,
    amps: 16,
    departureTime: '07:00',
    customKw: 11.0,
    region: 'uk',
    efficiency: 90,
    theme: 'dark'
};
function $fb7559346d9f31fe$export$53ac33307b5acee9() {
    let state = {
        ...$fb7559346d9f31fe$var$DEFAULT_STATE
    };
    state.region = (0, $da10314c8029a7e4$export$cce993fac5dd4f0d)();
    const saved = localStorage.getItem($fb7559346d9f31fe$var$STORAGE_KEY);
    if (saved) state = {
        ...state,
        ...JSON.parse(saved)
    };
    else {
        // Try legacy keys
        const legacyBattery = localStorage.getItem('batteryCapacity');
        const legacySpeed = localStorage.getItem('chargingSpeed');
        const legacyCurrent = localStorage.getItem('currentCharge');
        const legacyTarget = localStorage.getItem('desiredCharge');
        const legacyTime = localStorage.getItem('chargeByTime');
        if (legacyBattery) state.batteryCapacity = parseFloat(legacyBattery);
        if (legacySpeed) state.chargingSpeed = parseFloat(legacySpeed);
        if (legacyCurrent) state.currentSoC = parseFloat(legacyCurrent);
        if (legacyTarget) state.targetSoC = parseFloat(legacyTarget);
        if (legacyTime) state.departureTime = legacyTime;
        // Set default volts from region if first run
        state.volts = (0, $cd24e25165f686be$export$36b79d2b85570e14)[state.region].volts;
    }
    return state;
}
function $fb7559346d9f31fe$export$fb931cd598921492(state) {
    localStorage.setItem($fb7559346d9f31fe$var$STORAGE_KEY, JSON.stringify(state));
}


function $7e5161ecce18be00$export$88cf8da155ee6987(state) {
    const energyNeeded = (state.targetSoC - state.currentSoC) / 100 * state.batteryCapacity;
    let speed = state.chargingSpeed;
    let vaResultKw;
    if (state.powerMode === 'va') {
        speed = state.volts * state.amps / 1000;
        vaResultKw = speed.toFixed(2);
    }
    const efficiencyFactor = state.efficiency / 100;
    const effectiveSpeed = speed * efficiencyFactor;
    const energyFromWall = energyNeeded / efficiencyFactor;
    const hoursNeeded = effectiveSpeed > 0 ? energyNeeded / effectiveSpeed : 0;
    const hours = Math.floor(hoursNeeded);
    const mins = Math.round((hoursNeeded - hours) * 60);
    // Time calculation
    const [depH, depM] = state.departureTime.split(':').map(Number);
    const depDate = new Date();
    depDate.setHours(depH, depM, 0, 0);
    const plugDate = new Date(depDate.getTime() - hoursNeeded * 3600000);
    // Format Departure for display
    const departureLabel = depDate.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
    });
    // Format Plug-in Time
    let plugH = plugDate.getHours();
    const ampm = plugH >= 12 ? 'PM' : 'AM';
    plugH = plugH % 12;
    plugH = plugH ? plugH : 12; // the hour '0' should be '12'
    const plugM = plugDate.getMinutes().toString().padStart(2, '0');
    return {
        energyNeeded: energyNeeded,
        energyFromWall: energyFromWall,
        hoursNeeded: hoursNeeded,
        hours: hours,
        mins: mins,
        departureLabel: departureLabel,
        plugTime: {
            time: `${plugH.toString().padStart(2, '0')}:${plugM}`,
            ampm: ampm
        },
        vaResultKw: vaResultKw
    };
}



function $ad3955d50a935240$export$49e16ec648d05eb2(state) {
    const root = document.documentElement;
    if (state.theme === 'light') {
        root.classList.add('light-mode');
        (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).themeIcon.className = 'ph ph-sun';
    } else {
        root.classList.remove('light-mode');
        (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).themeIcon.className = 'ph ph-moon';
    }
}




function $6fb63ec89304b6ee$export$e182aac5c2493cd4(state, onSpeedChange) {
    const region = (0, $cd24e25165f686be$export$36b79d2b85570e14)[state.region];
    (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).voltageText.innerText = `Suggested Amps are calculated at ${region.volts}V`;
    let html = '';
    region.presets.forEach((p)=>{
        const volts = p.v || region.volts;
        const kw = volts * p.a / 1000;
        const isChecked = state.chargingSpeed === kw;
        html += `
            <label class="radio-item">
                <input type="radio" name="speed" value="${kw}" ${isChecked ? 'checked' : ''}>
                <div class="radio-box">
                    <span class="radio-val">${kw.toFixed(1)}</span>
                    <span class="radio-sub"><i class="ph-fill ph-lightning" style="font-size: 8px;"></i> ${p.a}A</span>
                </div>
            </label>
        `;
    });
    // Add Custom Option
    const isCustom = !region.presets.some((p)=>(p.v || region.volts) * p.a / 1000 === state.chargingSpeed);
    html += `
        <label class="radio-item col-span-2">
            <input type="radio" name="speed" value="custom" id="speedCustom" ${isCustom ? 'checked' : ''}>
            <div class="radio-box custom-box font-sans">
                <i class="ph ph-faders"></i>
                <span class="radio-val" style="font-size: 0.75rem; font-weight: 500;">Custom kW</span>
            </div>
        </label>
    `;
    (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).presetContainer.innerHTML = html;
    // Re-attach listeners for newly created elements
    document.querySelectorAll('input[name="speed"]').forEach((r)=>{
        r.addEventListener('change', (e)=>{
            const target = e.target;
            let newSpeed;
            let custom = false;
            if (target.value === 'custom') {
                (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).customKwInput.style.display = 'block';
                newSpeed = parseFloat((0, $5c44653aa16276b5$export$7a5d735b2ab6389d).customKwValue.value) || 0;
                custom = true;
            } else {
                (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).customKwInput.style.display = 'none';
                newSpeed = parseFloat(target.value);
            }
            onSpeedChange(newSpeed, custom);
        });
    });
    if (isCustom && state.powerMode === 'kw') (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).customKwInput.style.display = 'block';
    else (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).customKwInput.style.display = 'none';
}



function $b9e0f7ba9d8d5ca9$export$64906acaaa742e7e(results) {
    (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).resEnergy.innerText = results.energyNeeded.toFixed(1);
    (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).resWallEnergy.innerText = results.energyFromWall.toFixed(1);
    (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).resHours.innerText = results.hours.toString();
    (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).resMins.innerText = results.mins.toString();
    (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).resDeparture.innerText = results.departureLabel;
    (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).resPlugTime.innerText = results.plugTime.time;
    (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).resPlugAMPM.innerText = results.plugTime.ampm;
    if (results.vaResultKw) (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).vaResultKw.innerText = results.vaResultKw;
}



class $f7b2aa98c40a7868$export$817c52ec18edf50b {
    constructor(onUpdate){
        this.isDragging = null;
        this.onUpdate = onUpdate;
    }
    updateUI(state) {
        (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).currentSoCVal.innerText = state.currentSoC.toString();
        (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).targetSoCVal.innerText = state.targetSoC.toString();
        (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).handleCurrent.style.left = state.currentSoC + '%';
        (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).handleTarget.style.left = state.targetSoC + '%';
        (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).sliderFill.style.left = state.currentSoC + '%';
        (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).sliderFill.style.width = state.targetSoC - state.currentSoC + '%';
    }
    init(state) {
        const updateFromPointer = (e)=>{
            const rect = (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).socSlider.getBoundingClientRect();
            let clientX;
            if ('touches' in e) clientX = e.touches[0].clientX;
            else clientX = e.clientX;
            const x = clientX - rect.left;
            let percent = Math.round(x / rect.width * 100);
            percent = Math.max(0, Math.min(100, percent));
            let current = state.currentSoC;
            let target = state.targetSoC;
            if (this.isDragging === 'current') current = Math.min(percent, state.targetSoC - 1);
            else if (this.isDragging === 'target') target = Math.max(percent, state.currentSoC + 1);
            this.onUpdate(current, target);
        };
        const onStart = (type)=>(e)=>{
                this.isDragging = type;
                const onEnd = ()=>{
                    this.isDragging = null;
                    document.removeEventListener('mousemove', updateFromPointer);
                    document.removeEventListener('mouseup', onEnd);
                    document.removeEventListener('touchmove', updateFromPointer);
                    document.removeEventListener('touchend', onEnd);
                };
                document.addEventListener('mousemove', updateFromPointer);
                document.addEventListener('mouseup', onEnd);
                document.addEventListener('touchmove', updateFromPointer);
                document.addEventListener('touchend', onEnd);
                e.preventDefault();
            };
        (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).handleCurrent.addEventListener('mousedown', onStart('current'));
        (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).handleCurrent.addEventListener('touchstart', onStart('current'));
        (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).handleTarget.addEventListener('mousedown', onStart('target'));
        (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).handleTarget.addEventListener('touchstart', onStart('target'));
        (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).socSlider.addEventListener('mousedown', (e)=>{
            if (e.target !== (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).handleCurrent && e.target !== (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).handleTarget) {
                const rect = (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).socSlider.getBoundingClientRect();
                const x = e.clientX - rect.left;
                const percent = Math.round(x / rect.width * 100);
                let current = state.currentSoC;
                let target = state.targetSoC;
                if (Math.abs(percent - current) < Math.abs(percent - target)) {
                    current = Math.min(percent, target - 1);
                    this.isDragging = 'current';
                } else {
                    target = Math.max(percent, current + 1);
                    this.isDragging = 'target';
                }
                this.onUpdate(current, target);
                onStart(this.isDragging)(e);
            }
        });
    }
}


let $36d5a33d9da87b96$var$state;
const $36d5a33d9da87b96$var$slider = new (0, $f7b2aa98c40a7868$export$817c52ec18edf50b)((current, target)=>{
    $36d5a33d9da87b96$var$state.currentSoC = current;
    $36d5a33d9da87b96$var$state.targetSoC = target;
    $36d5a33d9da87b96$var$updateUI();
    $36d5a33d9da87b96$var$calculate();
    (0, $fb7559346d9f31fe$export$fb931cd598921492)($36d5a33d9da87b96$var$state);
});
function $36d5a33d9da87b96$var$init() {
    $36d5a33d9da87b96$var$state = (0, $fb7559346d9f31fe$export$53ac33307b5acee9)();
    // Sync inputs with state
    (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).batteryCapacity.value = $36d5a33d9da87b96$var$state.batteryCapacity.toString();
    (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).efficiencySlider.value = $36d5a33d9da87b96$var$state.efficiency.toString();
    (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).efficiencyVal.innerText = $36d5a33d9da87b96$var$state.efficiency.toString();
    (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).departureTime.value = $36d5a33d9da87b96$var$state.departureTime;
    (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).customKwValue.value = $36d5a33d9da87b96$var$state.customKw.toString();
    (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).inputVolts.value = $36d5a33d9da87b96$var$state.volts.toString();
    (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).inputAmps.value = $36d5a33d9da87b96$var$state.amps.toString();
    (0, $ad3955d50a935240$export$49e16ec648d05eb2)($36d5a33d9da87b96$var$state);
    $36d5a33d9da87b96$var$slider.init($36d5a33d9da87b96$var$state);
    $36d5a33d9da87b96$var$setupEventListeners();
    $36d5a33d9da87b96$var$updateUI();
    $36d5a33d9da87b96$var$calculate();
}
function $36d5a33d9da87b96$var$setupEventListeners() {
    (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).themeToggle.addEventListener('click', ()=>{
        $36d5a33d9da87b96$var$state.theme = $36d5a33d9da87b96$var$state.theme === 'dark' ? 'light' : 'dark';
        (0, $ad3955d50a935240$export$49e16ec648d05eb2)($36d5a33d9da87b96$var$state);
        (0, $fb7559346d9f31fe$export$fb931cd598921492)($36d5a33d9da87b96$var$state);
    });
    (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).batteryCapacity.addEventListener('input', (e)=>{
        const target = e.target;
        $36d5a33d9da87b96$var$state.batteryCapacity = parseFloat(target.value) || 0;
        $36d5a33d9da87b96$var$calculate();
        (0, $fb7559346d9f31fe$export$fb931cd598921492)($36d5a33d9da87b96$var$state);
    });
    (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).efficiencySlider.addEventListener('input', (e)=>{
        const target = e.target;
        $36d5a33d9da87b96$var$state.efficiency = parseInt(target.value) || 90;
        (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).efficiencyVal.innerText = $36d5a33d9da87b96$var$state.efficiency.toString();
        $36d5a33d9da87b96$var$calculate();
        (0, $fb7559346d9f31fe$export$fb931cd598921492)($36d5a33d9da87b96$var$state);
    });
    (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).departureTime.addEventListener('input', (e)=>{
        const target = e.target;
        $36d5a33d9da87b96$var$state.departureTime = target.value;
        $36d5a33d9da87b96$var$calculate();
        (0, $fb7559346d9f31fe$export$fb931cd598921492)($36d5a33d9da87b96$var$state);
    });
    (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).togglePowerMode.addEventListener('click', ()=>{
        $36d5a33d9da87b96$var$state.powerMode = $36d5a33d9da87b96$var$state.powerMode === 'kw' ? 'va' : 'kw';
        $36d5a33d9da87b96$var$updateUI();
        $36d5a33d9da87b96$var$calculate();
        (0, $fb7559346d9f31fe$export$fb931cd598921492)($36d5a33d9da87b96$var$state);
    });
    (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).customKwValue.addEventListener('input', (e)=>{
        const target = e.target;
        $36d5a33d9da87b96$var$state.customKw = parseFloat(target.value) || 0;
        $36d5a33d9da87b96$var$state.chargingSpeed = $36d5a33d9da87b96$var$state.customKw;
        $36d5a33d9da87b96$var$calculate();
        (0, $fb7559346d9f31fe$export$fb931cd598921492)($36d5a33d9da87b96$var$state);
    });
    (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).inputVolts.addEventListener('input', (e)=>{
        const target = e.target;
        $36d5a33d9da87b96$var$state.volts = parseFloat(target.value) || 0;
        $36d5a33d9da87b96$var$calculate();
        (0, $fb7559346d9f31fe$export$fb931cd598921492)($36d5a33d9da87b96$var$state);
    });
    (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).inputAmps.addEventListener('input', (e)=>{
        const target = e.target;
        $36d5a33d9da87b96$var$state.amps = parseFloat(target.value) || 0;
        $36d5a33d9da87b96$var$calculate();
        (0, $fb7559346d9f31fe$export$fb931cd598921492)($36d5a33d9da87b96$var$state);
    });
}
function $36d5a33d9da87b96$var$updateUI() {
    if ($36d5a33d9da87b96$var$state.powerMode === 'kw') {
        (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).toggleText.innerText = 'Use Volts/Amps';
        (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).kwSelector.classList.remove('hidden');
        (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).vaSelector.classList.add('hidden');
        (0, $6fb63ec89304b6ee$export$e182aac5c2493cd4)($36d5a33d9da87b96$var$state, (speed, isCustom)=>{
            $36d5a33d9da87b96$var$state.chargingSpeed = speed;
            if (isCustom) $36d5a33d9da87b96$var$state.customKw = speed;
            $36d5a33d9da87b96$var$calculate();
            (0, $fb7559346d9f31fe$export$fb931cd598921492)($36d5a33d9da87b96$var$state);
        });
    } else {
        (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).toggleText.innerText = 'Use kW Presets';
        (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).kwSelector.classList.add('hidden');
        (0, $5c44653aa16276b5$export$7a5d735b2ab6389d).vaSelector.classList.remove('hidden');
    }
    $36d5a33d9da87b96$var$slider.updateUI($36d5a33d9da87b96$var$state);
}
function $36d5a33d9da87b96$var$calculate() {
    const results = (0, $7e5161ecce18be00$export$88cf8da155ee6987)($36d5a33d9da87b96$var$state);
    (0, $b9e0f7ba9d8d5ca9$export$64906acaaa742e7e)(results);
}
$36d5a33d9da87b96$var$init();


//# sourceMappingURL=ev-charge-time-calculator.728367b2.js.map
